import React from "react";
import l from "components/util/l";

const Bullets = ({ items = [] }) =>
  items?.length ? (
    <ul className="mb-2 pl-3">
      {items.map((x, i) => <li key={i}>{x}</li>)}
    </ul>
  ) : null;

const Chips = ({ items = [] }) =>
  items?.length ? (
    <div className="mt-2 d-flex flex-wrap">
      {items.map((x, i) => (
        <span key={i} className="badge badge-light mr-2 mb-2">{x}</span>
      ))}
    </div>
  ) : null;

const DocumentationModal = ({ doc, onClose }) => {
  const about = doc?.about || {};
  const fields = Array.isArray(doc?.fields) ? doc.fields : [];

  return (
    <>
      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        onClick={onClose}
      >
        <div
          className="modal-dialog modal-lg modal-dialog-scrollable"
          role="document"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                <i className="fas fa-book mr-2"></i>
                {l("Documentación%SA256")}
              </h5>
              <button type="button" className="close" aria-label="Close" onClick={onClose}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              {(about.what_is || about.use_cases || about.how_it_works) && (
                <div className="mb-4">
                  <h5 className="mb-2">{l("¿Qué es esta acción?%SA257")}</h5>

                  {about.what_is && <p className="mb-2">{about.what_is}</p>}

                  {Array.isArray(about.use_cases) && about.use_cases.length > 0 && (
                    <>
                      <h6 className="mt-3">{l("¿Dónde se puede usar?%SA258")}</h6>
                      <Bullets items={about.use_cases} />
                    </>
                  )}

                  {Array.isArray(about.how_it_works) && about.how_it_works.length > 0 && (
                    <>
                      <h6 className="mt-3">{l("Cómo funciona%SA259")}</h6>
                      <ol className="mb-2 pl-3">
                        {about.how_it_works.map((x, i) => <li key={i}>{x}</li>)}
                      </ol>
                    </>
                  )}
                </div>
              )}

              {fields.length > 0 && (
                <>
                  <h5 className="mb-2">{l("Campos del formulario (qué poner)%SA260")}</h5>
                  <div className="table-responsive">
                    <table className="table table-sm table-striped mb-0">
                      <thead className="thead-light">
                        <tr>
                          <th>{l("Campo%SA261")}</th>
                          <th>{l("Qué poner%SA262")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {fields.map((f, i) => (
                          <tr key={i}>
                            <td className="align-middle">
                              <div className="d-flex align-items-center flex-wrap">
                                <strong className="mr-2">{f.label || f.name}</strong>
                                {f.show_if && (
                                  <span className="badge badge-info">
                                    {l("Visible si%SA263")} {f.show_if}
                                  </span>
                                )}
                              </div>
                            </td>

                            <td>
                              {f.what_it_does && (
                                <div className="text-muted small mb-1">
                                  {f.what_it_does}
                                </div>
                              )}

                              {Array.isArray(f.example_list) && f.example_list.length > 0 ? (
                                <Chips items={f.example_list} />
                              ) : (
                                f.example && <Chips items={[f.example]} />
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                {l("Cerrar%SA264")}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Backdrop Bootstrap */}
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default DocumentationModal;